import React from 'react';

export default function useEffectOnce(callback: () => void): ReturnType<typeof React.useEffect> {
  return React.useEffect(callback, []);
}
